<template>
  <a-card :bordered="false">
    <a-form>
      <search-header :col="3">
        <search-list>
          <a-form-item>
            <a-input v-model="queryParams.bussinessName" placeholder="请输入商家名称"></a-input>
          </a-form-item>
          <a-form-item style="margin-left:10px;">
            <a-button style="margin-right: 10px;" type="primary" @click="searchBtn">查询</a-button>
            <a-button style="margin-right: 10px;" type="primary" @click="showModal">新增</a-button>
            <a-button style="margin-right: 10px" @click="showImport">批量导入</a-button>
            <a-upload
              :action="uploadFileUrl"
              :multiple="false"
              :showUploadList="false"
              @change="handleCodeChange"
              :before-upload="beforeUploadCodeFile"
            >
              <a-button :icon="loading?'loading':'upload'">二维码模板</a-button>
            </a-upload>
          </a-form-item>
        </search-list>
      </search-header>
    </a-form>
    <custom-page-table
      ref="table"
      :queryParams="queryParams"
      :columns="getColumns()"
      :request-promise="loadPromise"
    >
      <span slot="address" slot-scope="rowItem" style="word-break: break-all">
        {{ rowItem.text }}
      </span>
      <span slot="license" slot-scope="rowItem">
        <img v-if="rowItem.record.license" style="width: 100px;height: 100px" :src="rowItem.record.license" alt="">
      </span>
      <span slot="qrcode" slot-scope="rowItem">
        <img v-if="rowItem.record.qrcode" style="width: 100px;height: 100px" :src="rowItem.record.qrcode" alt="">
      </span>
      <div slot="action" slot-scope="rowItem">
        <a @click="handleContent(rowItem.record.id)">编辑</a>
        <a-divider type="vertical"></a-divider>
        <a-popconfirm
          title="你确定要下载二维码吗?"
          @confirm="downloadContent(rowItem.record)">
          <a>下载二维码</a>
        </a-popconfirm>
      </div>
    </custom-page-table>
    <a-modal
      :title="id?'编辑商家':'新增商家'"
      :width="666"
      v-model="visible"
      :footer="null"
      @cancel="visible = false"
    >
      <a-form-model
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol">
        <a-form-model-item label="商家名称" prop="bussinessName">
          <a-input v-model="ruleForm.bussinessName" placeholder="请输入" :maxLength="13" style="max-width: 300px;"/>
        </a-form-model-item>
        <a-form-model-item label="商家地址" prop="address">
          <a-input v-model="ruleForm.address" placeholder="请输入" :maxLength="100" style="max-width: 300px;"/>
        </a-form-model-item>
        <a-form-model-item label="商家电话">
          <a-input placeholder="请输入" v-model="ruleForm.phone" :maxLength="30" style="max-width: 300px;"/>
        </a-form-model-item>
        <a-form-model-item label="营业执照">
          <a-upload
            :action="uploadFileUrl"
            :multiple="false"
            :showUploadList="false"
            listType="picture-card"
            @change="handleChange"
            :before-upload="beforeUploadFile"
          >
            <img v-if="ruleForm.license" :src="ruleForm.license" alt="avatar" class="selected-image"/>
            <div v-else>
              <a-icon :type="loading?'loading':'plus'"/>
              <br>上传
            </div>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{offset:6}">
          <a-button type="primary" @click="submitForm" :loading="submitLoading">保存设置</a-button>
        </a-form-model-item>
      </a-form-model>

    </a-modal>
    <ImportFileDialog
      accept=".xls,.xlsx"
      v-if="importVisible"
      :show="importVisible"
      @ok="importSuccess"
      @cancel="importVisible=false"
      :templateUrl="templateFileUrl"
      :url="exportUrl"></ImportFileDialog>
  </a-card>
</template>

<script>
import store from '@/store'
import ImportFileDialog from '@/views/service/serviceProvider/smartConnection/components/ImportFileDialog'
import downLoadHelper from '@/utils/helper/downLoadHelper'

export default {
  name: 'ShopList',
  components: {
    ImportFileDialog
  },
  data() {
    return {
      visible: false,
      loadPromise: params => this.getListPromise(params),
      queryParams: {},
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      ruleForm: {
        bussinessName: '',
        address: '',
        license: '',
        phone: ''
      },
      rules: {
        bussinessName: [{ required: true, message: '请输入', trigger: 'blur' }],
        address: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      uploadFileUrl: this.getUploadFileUrl(),
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      submitLoading: false,
      id: '',
      headers: {},
      exportUrl: '',
      importVisible: false,
      templateFileUrl: 'https://imgb.woyoubooking.com/config/huangYaoImportTemplate.xlsx',
      loading: false
    }
  },
  mounted() {
    this.exportUrl = store.getters.appConfig.serviceUrl + '/v2/comment-business/save-batch?platformId=' + this.platformId + '&merchantId=' + this.merchantId
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ShopEvaluateList', title: '商家管理' },
      { name: 'EvaluationList', title: '评价管理' }
    ])
  },
  methods: {
    searchBtn() {
      this.$refs.table.refresh(true)
    },
    importSuccess() {
      this.importVisible = false
      this.$nextTick(() => this.$refs.table.refresh(true))
    },
    showImport() {
      this.importVisible = true
    },
    getListPromise(params) {
      params.merchantId = this.merchantId
      params.platformId = this.platformId
      return this.getHttpServices().getServerApiService().post('v2/comment-business/list', params)
    },
    getUploadFileUrl() {
      let appConfig = this.getAppConfig()
      return appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
    },
    showModal() {
      this.id = ''
      this.ruleForm.bussinessName = ''
      this.ruleForm.address = ''
      this.ruleForm.license = ''
      this.ruleForm.phone = ''
      this.visible = true
    },
    downloadContent(record) {
      let params = {
        businessId: record.id,
        merchantId: this.merchantId,
        platformId: this.platformId,
        codeType: 1
      }
      this.getHttpServices().getServerApiService().post('v2/create/bill', params)
        .then(res => {
          let imageUrl = record.id + '_' + record.bussinessName + '.png'
          downLoadHelper.downloadImage(imageUrl, res.billUrl)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.submitLoading = false)
    },
    handleContent(id) {
      this.id = id
      this.visible = true
      this.getDetails(id)
    },
    getDetails(id) {
      this.getHttpServices().getServerApiService().post('/v2/comment-business/' + id)
        .then(res => {
          this.ruleForm.bussinessName = res.bussinessName
          this.ruleForm.address = res.address
          this.ruleForm.license = res.license
          this.ruleForm.phone = res.phone
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.submitLoading = false)
    },
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    //更新提现设置
    submitData() {
      this.submitLoading = true
      let params = {
        bussinessName: this.ruleForm.bussinessName,
        address: this.ruleForm.address,
        license: this.ruleForm.license,
        phone: this.ruleForm.phone,
        merchantId: this.merchantId,
        platformId: this.platformId,
        id: this.id
      }
      this.getHttpServices().getServerApiService().post('v2/comment-business/save', params)
        .then(res => {
          this.$message.success('保存成功')
          this.submitLoading = false
          this.visible = false
          this.$refs.table.refresh()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.submitLoading = false)
    },
    beforeUploadFile(file) {
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isJPG && !isPNG && !isJPEG) {
        this.$message.error('请选择正确的图片格式上传!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!')
        return false
      }
      return true
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        this.ruleForm.license = this.getLatestUrlFromFileList(info.fileList)
        this.loading = false
      }
    },
    getLatestUrlFromFileList(fileList) {
      if (fileList && fileList.length > 0) {
        const lastIndex = fileList.length - 1
        if (fileList[lastIndex] && fileList[lastIndex].response) {
          return fileList[lastIndex].response.data
        }
      }
      return ''
    },
    handleCodeChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        this.loading = false
        let codeImage = this.getLatestUrlFromFileList(info.fileList)
        this.uploadCommentBackImg(codeImage)
      }
    },
    uploadCommentBackImg(img) {
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        img
      }
      this.getHttpServices().getServerApiService().post('v2/commentBackImg/save', params).then(res => {
        this.$message.success('二维码模板上传成功')
        this.searchBtn()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    beforeUploadCodeFile(file) {
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isJPG && !isPNG && !isJPEG) {
        this.$message.error('请选择正确的图片格式上传!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!')
        return false
      }
      let that = this
      return new Promise(function(resolve, reject) {
        let fileReader = new FileReader()
        let width = 1182
        let height = 1772
        fileReader.onload = e => {
          let src = e.target.result
          const image = new Image()
          image.onload = function() {
            let valid = image.width == width && image.height == height
            if (!valid) {
              that.$message.error('上传的图片尺寸必须是1182px*1772px(宽高)')
              reject()
            } else {
              resolve()
            }
          }
          image.onerror = reject
          image.src = src
        }
        fileReader.readAsDataURL(file)
      })
      return true
    },
    getColumns() {
      return [
        {
          title: '商家ID',
          dataIndex: 'id'
        },
        {
          title: '商家名称',
          dataIndex: 'bussinessName'
        },
        {
          title: '商家地址',
          dataIndex: 'address',
          scopedSlots: { customRender: 'address' }
        },
        {
          title: '商家电话',
          dataIndex: 'phone'
        },
        {
          title: '营业执照',
          dataIndex: 'license',
          scopedSlots: { customRender: 'license' }
        },
        {
          title: '评分',
          dataIndex: 'averageScore'
        },
        {
          title: '二维码',
          dataIndex: 'qrcode',
          scopedSlots: { customRender: 'qrcode' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.button-box {
  margin-bottom: 20px;
}

.selected-image {
  width: 100px;
  height: 100px;
}
</style>